<template>
  <div>
    <v-row class="pa-0 ma-0" v-if="felevek.length > 0">
      <v-divider class="mx-5"></v-divider>
      <p class="w-100 text-center ma-0 pa-0 my-3">{{ $store.state.lang.jelmagyarazat }}</p>
    </v-row>
    <v-row
      class="pa-0 mx-auto my-1 text-center d-flex justify-center"
      v-if="felevek.length > 0"
    >
      <v-col :cols="12" :lg="2" :md="2" :sm="6" :xs="6">
        <div class="color-box-yellow"></div>
        {{ $store.state.lang.kivalasztott_tantargy }}
      </v-col>
      <v-col :cols="12" :lg="2" :md="2" :sm="6" :xs="6"
        ><div class="color-box-darkblue"></div>
        -
        <div class="color-box-lightblue"></div>
        {{ $store.state.lang.elokovetelmeny }}</v-col
      >
      <v-col :cols="12" :lg="2" :md="2" :sm="6" :xs="6"
        ><div class="color-box-darkred"></div>
        -
        <div class="color-box-lightred"></div>
        {{ $store.state.lang.raepules }}</v-col
      >
      <v-col :cols="12" :lg="2" :md="2" :sm="6" :xs="6"
        ><div class="color-box-green"></div>
        {{ $store.state.lang.felveheto_tantargyak }}</v-col
      >
      <v-col :cols="12" :lg="2" :md="2" :sm="6" :xs="6"
        ><div class="color-box-darkgreen"></div>
        {{ $store.state.lang.teljesitett_targyak }}</v-col
      >
    </v-row>
  </div>
</template>
<script>
export default {
  props: ["felevek"],
  name: "Jelmagyarazat",
  data: () => ({}),

};
</script>
<style>
.color-box-yellow {
  display: inline-block;
  height: 2vh;
  width: 2vh;
  background-color: #fb8c00;
}
.color-box-darkblue {
  display: inline-block;
  height: 2vh;
  width: 2vh;
  background-color: #0a192f;
}
.color-box-lightblue {
  display: inline-block;
  height: 2vh;
  width: 2vh;
  background-color: #f0f9ff;
}
.color-box-darkred {
  display: inline-block;
  height: 2vh;
  width: 2vh;
  background-color: #330000;
}
.color-box-lightred {
  display: inline-block;
  height: 2vh;
  width: 2vh;
  background-color: #fff5f5;
}
.color-box-green {
  display: inline-block;
  height: 2vh;
  width: 2vh;
  background-color: #81c784;
}
.color-box-darkgreen {
  display: inline-block;
  height: 2vh;
  width: 2vh;
  background-color: #18960c;
}
</style>